import React, { useState, useEffect, useContext } from 'react';
import MachineQRCode from './MachineQRCode';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';
import { ReactComponent as FilterIcon } from '../assets/svg/icon-filter.svg';
import { ReactComponent as AddIcon } from '../assets/svg/icon-add.svg';
import './AddMachine.css';
import '../boxitem.css';
import '../topmenu.css';
import '../pageSearch.css';
import '../forms.css';
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import UploadedFileItem from './UploadedFileItem';
import { useNavigate, useLocation } from 'react-router-dom';
import GroupedDataTable from './GroupDataTable2'; 

const AddMachine = () => {
  const { t } = useTranslation();
  const [machine, setMachine] = useState('');
  const [dncmaxgroupname, setDncmaxgroupname] = useState('');
  const [newGroupName, setNewGroupName] = useState('');
  const [visibility, setVisibility] = useState(1);
  const [category, setCategory] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [system, setSystem] = useState('');
  const [notes, setNotes] = useState('');
  const [machinesMaintenances, setMachinesMaintenances] = useState({});
  const [groupNames, setGroupNames] = useState([]);
  const [categories, setCategories] = useState([]); // Machine categories from settings
  const [formVisible, setFormVisible] = useState(false);
  const [machines, setMachines] = useState([]);
  const [sortedMachines, setSortedMachines] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editMachineId, setEditMachineId] = useState(null);
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [restrictedEditing, setRestrictedEditing] = useState(false);
  const [permissions, setPermissions] = useState({ can_edit: false, can_delete: false, can_view: true });
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);
  const [sortOrder, setSortOrder] = useState('asc');
  const [dragOver, setDragOver] = useState(false);
  const [sortBy, setSortBy] = useState('dncmaxgroupname');
  const [files, setFiles] = useState([]);
  const [fileTitles, setFileTitles] = useState([]);
  // NEW: State for file category selection for new uploaded files
  const [fileCategories, setFileCategories] = useState([]);
  // previewFiles holds existing files (loaded during edit mode)
  const [previewFiles, setPreviewFiles] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showContent, setShowContent] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [uploadError, setUploadError] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [currencyPosition, setCurrencyPosition] = useState('right');
  const [selectedMachineCost, setSelectedMachineCost] = useState(null);
  const [isCostModalOpen, setIsCostModalOpen] = useState(false);
  const [overAllMachineCost, setOverAllMachineCost] = useState(0);
  const [responsibleTechs, setResponsibleTechs] = useState([]);
  const [showResponsibleTechs, setShowResponsibleTechs] = useState(false);


// New state: available file categories from backend API
const [availableFileCategories, setAvailableFileCategories] = useState([]);
// New state: for each new file, capture the new (override) category if the user types one
const [newFileCategories, setNewFileCategories] = useState([]);

  // NEW: State for which machine’s QR code is shown
  const [qrCodeMachine, setQrCodeMachine] = useState(null);

  // NEW: Separate file upload category options for new uploads.
  const fileUploadCategoriesOptions = [

  ];

  // NEW: New state for physical document placement
  const [placement, setPlacement] = useState('');
  const [newPlacement, setNewPlacement] = useState('');
  // NEW: Dropdown options for placements (populated from all machines)
  const [placements, setPlacements] = useState([]);

  
  const toggleMenu = (event, machineId) => {
    event.stopPropagation();
    setOpenMenu(openMenu === machineId ? null : machineId);
  };
  
  const confirmDelete = (machineId) => {
    if (window.confirm(t('addMachine.confirmDelete'))) {
      handleDelete(machineId);
    }
    setOpenMenu(null);
  };

  const apiBaseUrl = useContext(ApiBaseUrlContext);

  const getPriorityClass = (priority) => {
    switch (priority) {
      case 'High':
        return 'red';
      case 'Medium':
        return 'yellow';
      case 'Low':
        return 'green';
      default:
        return '';
    }
  };

  const [reseller, setReseller] = useState({
    company_name: '',
    address: '',
    contact_name: '',
    contact_phone: '',
    contact_email: '',
    date_of_purchase: ''
  });
  const [externalTechs, setExternalTechs] = useState([]);
  const [availableExternalTechs, setAvailableExternalTechs] = useState([]);
  const [availableUsers, setAvailableUsers] = useState([]);
  
  useEffect(() => {
    if (editMode && editMachineId) {
      axios.get(`/mnt/api/machines/${editMachineId}/reseller`)
        .then((res) => {
          if (res.data) setReseller(res.data);
        })
        .catch(() => {});

      axios.get(`/mnt/api/machines/${editMachineId}/external-techs`)
        .then(res => setExternalTechs(res.data.map(t => t.userid)))
        .catch(() => {});

      axios.get(`/mnt/api/technicians`)
        .then(res => {
          setAvailableUsers(res.data);
          console.log(res.data);
          const filtered = res.data.filter(t => t.user_rights === 'external technician');
          setAvailableExternalTechs(filtered);
        })
        .catch(() => {});
        axios.get(`${apiBaseUrl}/mnt/api/machines/filecategories`)
        .then(response => {
          setAvailableFileCategories(response.data);
        })
        .catch(err => {
          console.error("Error fetching file categories:", err);
        });
    }
  }, [editMode, editMachineId]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      const fetchPermissions = async () => {
        try {
          const response = await axios.get(`${apiBaseUrl}/mnt/api/roles/permissions/${decodedToken.user_rights}`);
          setPermissions({
            can_edit: response.data.some(permission => permission.permission_name === 'can_edit' && permission.can_edit === 1),
            can_view: response.data.some(permission => permission.permission_name === 'can_view' && permission.can_view === 1),
            can_delete: response.data.some(permission => permission.permission_name === 'can_delete' && permission.can_delete === 1)
          });
        } catch (error) {
          console.error('Error fetching permissions:', error);
        } finally {
          setPermissionsLoaded(true); // ✅ always mark as loaded
        }
      };
      fetchPermissions();
    } else {
      setPermissionsLoaded(true); // ✅ fallback in case no token is found
    }
  }, [apiBaseUrl]);
  
  useEffect(() => {
    axios.get(`${apiBaseUrl}/mnt/api/machines/filecategories`)
      .then(response => {
        setAvailableFileCategories(response.data);
      })
      .catch(err => {
        console.error("Error fetching file categories:", err);
      });
  }, [apiBaseUrl]);

  useEffect(() => {
    axios.get(`${apiBaseUrl}/mnt/api/machines/all?includeAll=true`)
      .then(async (response) => {
        const machinesData = response.data.sort((a, b) => b.machineid - a.machineid);
        const machineCostPromises = machinesData.map(async (machine) => {
          try {
            const costResponse = await axios.get(`${apiBaseUrl}/mnt/api/machines/cost/${machine.machineid}`);
            return { 
              ...machine, 
              machineTotalCost: costResponse.data.machineTotalCost,
              serviceReportTimeCost: costResponse.data.serviceReportTimeCost || 0,
              serviceReportMaterialCost: costResponse.data.serviceReportMaterialCost || 0,
              serviceReportTotalCost: costResponse.data.serviceReportTotalCost || 0,
              maintenanceTimeCost: costResponse.data.maintenanceTimeCost || 0,
              maintenanceMaterialCost: costResponse.data.maintenanceMaterialCost || 0,
              maintenanceTotalCost: costResponse.data.maintenanceTotalCost || 0 
            };
          } catch (err) {
            console.error(`Error fetching cost for machine ${machine.machineid}`, err);
            return { 
              ...machine, 
              machineTotalCost: 0,
              serviceReportTimeCost: 0,
              serviceReportMaterialCost: 0,
              serviceReportTotalCost: 0,
              maintenanceTimeCost: 0,
              maintenanceMaterialCost: 0,
              maintenanceTotalCost: 0 
            };
          }
        });
        const updatedMachines = await Promise.all(machineCostPromises);
        setMachines(updatedMachines);
        const totalCost = updatedMachines.reduce((sum, machine) => sum + machine.machineTotalCost, 0);
        setOverAllMachineCost(totalCost);
      })
      .catch(err => {
        console.error('Error fetching machines:', err);
      });
  }, [apiBaseUrl]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/settings`);
        const settings = response.data;
        setCurrencySymbol(settings.currencySymbol || 'kr');
        setCurrencyPosition(settings.currencyPosition || 'right');
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, [apiBaseUrl]);

  // NEW: Fetch preexisting physical document placements from all machines.
  useEffect(() => {
    axios.get(`${apiBaseUrl}/mnt/api/machines/placements`)
      .then(response => {
        setPlacements(response.data);
      })
      .catch(err => {
        console.error('Error fetching placements:', err);
      });
  }, [apiBaseUrl]);

  const handleShowCostDetails = (machine) => {
    setSelectedMachineCost({
      serviceReportTimeCost: machine.serviceReportTimeCost || 0,
      serviceReportMaterialCost: machine.serviceReportMaterialCost || 0,
      serviceReportTotalCost: machine.serviceReportTotalCost || 0,
      maintenanceTimeCost: machine.maintenanceTimeCost || 0,
      maintenanceMaterialCost: machine.maintenanceMaterialCost || 0,
      maintenanceTotalCost: machine.maintenanceTotalCost || 0,
      machineTotalCost: machine.machineTotalCost || 0,
    });
    setIsCostModalOpen(true);
  };

  useEffect(() => {
    axios.get(`${apiBaseUrl}/mnt/api/machines/get-group-names`)
      .then(response => {
        setGroupNames(response.data);
      })
      .catch(err => {
        console.error('Error fetching group names:', err);
      });

    axios.get(`${apiBaseUrl}/mnt/api/machines/all?includeAll=true`)
      .then(response => {
        const sortedMachines = response.data.sort((a, b) => b.machineid - a.machineid);
        setMachines(sortedMachines);
      })
      .catch(err => {
        console.error('Error fetching machines:', err);
      });

    axios.get(`${apiBaseUrl}/mnt/api/settings`)
      .then(response => {
        setCategories(response.data.categories || []);
      })
      .catch(err => {
        console.error('Error fetching categories:', err);
      });
  }, [apiBaseUrl]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".menu-container")) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const handlePaste = (event) => {
      const clipboardItems = event.clipboardData.items;
      for (let item of clipboardItems) {
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file) {
            setImage(file);
            setPreviewImage(URL.createObjectURL(file));
          }
        }
      }
    };
    window.addEventListener('paste', handlePaste);
    return () => {
      window.removeEventListener('paste', handlePaste);
    };
  }, []);

  const sortMachines = (machines) => {
    if (!machines || machines.length === 0) {
      setSortedMachines([]);
      return;
    }
    const sorted = [...machines].sort((a, b) => {
      let valA = a[sortBy]?.toString().toLowerCase() || '';
      let valB = b[sortBy]?.toString().toLowerCase() || '';
      if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
      if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    });
    const groupedMachines = {};
    sorted.forEach(machine => {
      let groupKey = machine[sortBy] || 'Unassigned';
      if (!groupedMachines[groupKey]) {
        groupedMachines[groupKey] = [];
      }
      groupedMachines[groupKey].push(machine);
    });
    setSortedMachines(groupedMachines);
  };

  useEffect(() => {
    sortMachines(machines);
  }, [machines, sortBy, sortOrder]);
    
  const handleSubmit = (e) => {
    if (!permissions.can_edit) return;
    e.preventDefault();
  
    const formData = new FormData();
    formData.append('machine', machine || '');
    if(newGroupName){
      formData.append('dncmaxgroupname', newGroupName || '');
    } else {
      formData.append('dncmaxgroupname', dncmaxgroupname || '');
    }
    formData.append('visibility', visibility);
    formData.append('category', category || '');
    formData.append('serial_number', serialNumber || '');
    formData.append('system', system || '');
    formData.append('notes', notes || '');
  
    // NEW: Append placement data (use newPlacement if provided)
    formData.append('placement', newPlacement ? newPlacement : placement);
  
    if (image) {
      formData.append('machineImage', image);
    }
  
    files.forEach(file => {
      formData.append('files', file);
    });
  
    formData.append('fileTitles', JSON.stringify(fileTitles));
  // Compute the final file categories for each selected file:
const finalFileCategories = fileCategories.map((cat, index) =>
  newFileCategories[index] && newFileCategories[index].trim() !== ''
    ? newFileCategories[index]
    : (cat !== '' ? cat : "Other")
);
formData.append('fileCategories', JSON.stringify(finalFileCategories));
formData.append('responsible_technicians', JSON.stringify(responsibleTechs));


    // NEW: When editing, include updated existing file metadata
    const strippedPreviewFiles = previewFiles.map(file => ({
      ...file,
      path: file.path.replace(`${apiBaseUrl}/mnt/api/uploads/machine/`, '/uploads/machines/')
    }));
    formData.append('existingFilePaths', JSON.stringify(strippedPreviewFiles));
    
    if (editMode) {
      axios.put(`${apiBaseUrl}/mnt/api/machines/${editMachineId}`, formData)
      .then(response => {
        const machineid = editMachineId;
        axios.post(`${apiBaseUrl}/mnt/api/machines/${machineid}/reseller`, reseller).catch(() => {});
        axios.post(`${apiBaseUrl}/mnt/api/machines/${machineid}/external-techs`, {
          technician_userids: externalTechs
        }).catch(() => {});
        alert(t('addMachine.updateSuccess'));
        const updatedMachines = machines.map(m => m.machineid === machineid ? { ...m, ...response.data } : m);
        setMachines(updatedMachines);
        setEditMode(false);
        setEditMachineId(null);
        setFormVisible(false);
        navigate({ search: '?refresh=' + new Date().getTime() }, { replace: true });
      })
      .catch(error => {
        console.error('There was an error updating the machine!', error);
        const message = error.response?.data || error.message || 'Error adding machine!';
        setUploadError(message);
      });
    } else {
      axios.post(`${apiBaseUrl}/mnt/api/machines`, formData, { withCredentials: true })
      .then(response => {
        const machineid = response.data.machineid;
        axios.post(`${apiBaseUrl}/mnt/api/machines/${machineid}/reseller`, reseller).catch(() => {});
        alert(t('addMachine.addSuccess'));
        setMachines([response.data, ...machines]);
        setFormVisible(false);
        navigate({ search: '?refresh=' + new Date().getTime() }, { replace: true });
      })
      .catch(error => {
        console.error('There was an error adding the machine!', error);
        const message = error.response?.data || error.message || 'Error adding machine!';
        setUploadError(message);
      });
    }
  
    // Reset form fields including the new placement fields
    setMachine('');
    setDncmaxgroupname('');
    setVisibility(1);
    setCategory('');
    setSerialNumber('');
    setSystem('');
    setNotes('');
    setImage(null);
    setFiles([]);
    setFileTitles([]);
    setFileCategories([]);
    setPlacement('');
    setNewPlacement('');
  };
    
  const handleEdit = (machineId) => {
    if (!permissions.can_edit) return;
    window.scrollTo(0, 0);
    axios.get(`${apiBaseUrl}/mnt/api/machines/${machineId}`)
      .then(response => {
        const machineToEdit = response.data;
        setVisibility(machineToEdit.visibility);
        setCategory(machineToEdit.category || '');
        setSerialNumber(machineToEdit.serial_number || '');
        setSystem(machineToEdit.system || '');
        setNotes(machineToEdit.notes || '');
        setPreviewImage(machineToEdit.image_path);
        setPlacement(machineToEdit.placement || '');
const headUserArray = machineToEdit.head_user
  ? machineToEdit.head_user.split(',').map(id => Number(id.trim())).filter(id => !isNaN(id))
  : [];
setResponsibleTechs(headUserArray);

        // Parse file paths; if file_paths is a string, parse it to get an array
        const parsedFilePaths = typeof machineToEdit.file_paths === 'string'
          ? JSON.parse(machineToEdit.file_paths)
          : machineToEdit.file_paths || [];
        // Make sure each file has a category (defaulting to "Other" if none)
        const filesWithCategory = parsedFilePaths.map(file => ({
          ...file,
          category: file.category || "Other"
        }));
        setPreviewFiles(
          filesWithCategory.map(file =>
            file.path.startsWith('/uploads/machines')
              ? { ...file, path: `${apiBaseUrl}/mnt/api/uploads/machine/${file.path.replace('/uploads/machines/', '')}` }
              : file
          )
        );
        // **NEW:** Initialize fileCategories state so the dropdowns show the current category.
        setFileCategories(filesWithCategory.map(file => file.category));
  
        // (Your code for other fields, e.g., placement, machine name, etc.)
        if (machineId < 5000) {
          setRestrictedEditing(true);
          setMachine(machineToEdit.machine || '');
          setDncmaxgroupname(machineToEdit.dncmaxgroupname || '');
        } else {
          setMachine(machineToEdit.machine || '');
          setDncmaxgroupname(machineToEdit.dncmaxgroupname || '');
          setRestrictedEditing(false);
        }
        setEditMode(true);
        setEditMachineId(machineId);
        setFormVisible(true);
        setShowForm(true);
        setShowContent(false);
      })
      .catch(error => {
        console.error('There was an error fetching the machine details!', error);
      });
  
    // Also fetch maintenance info, etc.
    axios.get(`${apiBaseUrl}/mnt/api/maintenance/${machineId}`)
      .then((response) => {
        const openMaintenances = response.data.filter(item => item.closed === null);
        const categorized = openMaintenances.reduce((acc, curr) => {
          const type = curr.maintenance_type.toLowerCase();
          if (!acc[type]) acc[type] = [];
          acc[type].push(curr);
          return acc;
        }, { daily: [], weekly: [], monthly: [], annually: [] });
        setMachinesMaintenances(categorized);
      })
      .catch((error) => {
        console.error('Error fetching maintenance schedules:', error);
      });
  };
  
  const handleDelete = (machineId) => {
    if (!permissions.can_delete) return;
    if (machineId < 5000) {
      alert(t('addMachine.restrictedDelete'));
      return;
    }
    const confirmDelete = window.confirm(t('addMachine.confirmDelete'));
    if (confirmDelete) {
      axios.delete(`${apiBaseUrl}/mnt/api/machines/${machineId}`)
        .then(() => {
          setMachines(machines.filter(m => m.machineid !== machineId));
          alert(t('addMachine.deleteSuccess'));
        })
        .catch(error => {
          console.error('There was an error deleting the machine!', error);
        });
    }
    window.location.reload();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      setImage(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  // Handle new file uploads: initialize titles and categories.
  const handleFilesChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
    const titles = selectedFiles.map(file => {
      const originalName = file.name;
      return originalName.includes('.')
        ? originalName.substring(0, originalName.lastIndexOf('.'))
        : originalName;
    });
    setFileTitles(titles);
    // Initialize both fileCategories and newFileCategories with empty strings (or "Other" as default)
    const defaultCats = selectedFiles.map(() => "");
    setFileCategories(defaultCats);
    setNewFileCategories(defaultCats);
  };
  

  const filteredMachines = Object.entries(sortedMachines).reduce((acc, [group, machineList]) => {
    const filteredList = machineList.filter(machine =>
      machine.machine?.toLowerCase().includes(searchQuery.toLowerCase())
    );
    if (filteredList.length > 0) {
      acc[group] = filteredList;
    }
    return acc;
  }, {});

  return (
    <>
      {showFilters && (
        <div className="filter-container" onClick={() => setShowFilters(!showFilters)}>
          <div className="filter" onClick={(e) => e.stopPropagation()}>
            <div className="filter__fields">
              <div className="filter__label">{t('addMachine.machineSort')}</div>
              <div className="entry-item">
                <select className="btn-primary" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                  <option value="machine">{t('addMachine.machineName')}</option>
                  <option value="dncmaxgroupname">{t('addMachine.groupName')}</option>
                  <option value="category">{t('addMachine.category')}</option>
                  <option value="system">{t('addMachine.system')}</option>
                </select>
              </div>
              <div className="entry-item">
                <input 
                  type="text"
                  placeholder={t('Search machines...')}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="entry-control"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {uploadError && (
        <div className="upload-error" style={{ color: 'red', marginBottom: '10px' }}>
          {uploadError}
        </div>
      )}

      {showForm && permissions.can_edit && (
        <form onSubmit={handleSubmit} className="form">
          <div className="modal-full">
            <div className="top-menu">
              <button type="submit" className="button--blue">
                {editMode ? t('addMachine.btnSaveEditMachine') : t('addMachine.btnSaveNewMachine')}
              </button>
              <div className="top-menu__button-space"></div>
              <button 
                type="button" 
                className="button--grey" 
                onClick={() => {
                  setShowForm(false);
                  setShowContent(true);
                  setFormVisible(false);
                  setEditMode(false);
                  setEditMachineId(null);
                  window.location.reload();
                }}
              >
                {t('personnelManagement.cancel')}
              </button>
            </div>

            <div className="content__main-title">
              {editMode ? t('addMachine.editMachine') : t('addMachine.addNewMachine')}
            </div>

            <div className="form-section__title">
              {t('addMachine.details')}
            </div>
            <div className="form-section">
              <div className="entry-item entry-item__medium">
                <label className="entry-label" htmlFor="machinename">{t('addMachine.machineName')}</label>
                <input
                  type="text"
                  id="machinename"
                  name="machinename"
                  className="entry-control"
                  value={machine || ''}
                  onChange={e => setMachine(e.target.value)} 
                  required
                  disabled={restrictedEditing}
                />
              </div>
              
              <div className="entry-item entry-item__content-width">
                <label className="entry-label" htmlFor="machinegroup">{t('addMachine.groupName')}</label>
                <select className="form-select"
                  id="machinegroup" 
                  value={dncmaxgroupname} 
                  onChange={e => setDncmaxgroupname(e.target.value)} 
                  required={!newGroupName} // ✅ only required if newGroupName is empty
                  disabled={restrictedEditing}>

                  {groupNames.map((name, index) => (
                    <option key={index} value={name}>{name}</option>
                  ))}
                </select>
                <input                 
                  className='entry-control' 
                  type="text" 
                  value={newGroupName || ''} 
                  onChange={e => setNewGroupName(e.target.value)} 
                />
              </div>            

              <div className="entry-item entry-item__content-width">
                <label htmlFor="category" className="entry-label">{t('addMachine.category')}</label>
                <select 
                  id="category"
                  name="category"
                  className="entry-control form-select" 
                  value={category || ''} 
                  onChange={e => setCategory(e.target.value)} 
                  required
                >
                  <option value="">{t('addMachine.selectCategory')}</option>
                  {categories.map((cat, index) => (
                    <option key={index} value={cat}>{cat}</option>
                  ))}
                </select>
              </div>

              <div className="entry-item entry-item__small">
                <label className='entry-label'>{t('addMachine.serialNumber')}</label>
                <input 
                  className='entry-control' 
                  type="text" 
                  value={serialNumber || ''} 
                  onChange={e => setSerialNumber(e.target.value)} 
                />
              </div>

              <div className="entry-item entry-item__medium">
                <label className='entry-label'>{t('addMachine.system')}</label>
                <input 
                  className='entry-control' 
                  type="text" 
                  value={system || ''} 
                  onChange={e => setSystem(e.target.value)} 
                />
              </div>

              <div className="entry-item entry-item__small">
                <label htmlFor="priority" className="entry-label">{t('addMachine.displayedPriority')}</label>
                <input
                  type="checkbox"
                  id="priority"
                  name="priority"
                  className="entry-control"
                  checked={visibility}
                  onChange={e => setVisibility(e.target.checked ? 1 : 0)}
                />
              </div>

              <div className="entry-item entry-item__full-width">
                <label className='entry-label'>{t('addMachine.notes')}</label>
                <textarea 
                  className='entry-control' 
                  value={notes || ''} 
                  onChange={e => setNotes(e.target.value)} 
                />
              </div>

              {/** NEW: Physical Document Placement section */}
              <div className="entry-item entry-item__content-width">
                <label className="entry-label" htmlFor="placement">{t('addMachine.placement')}</label>

                <div className="placement-fields">
                  <select
                    className="form-select"
                    id="placement"
                    value={placement}
                    onChange={(e) => setPlacement(e.target.value)}
                  >
                    <option value="">{t('addMachine.selectPlacement')}</option>
                    {placements.map((p, index) => (
                      <option key={index} value={p}>{p}</option>
                    ))}
                  </select>

                  <input
                    className="entry-control"
                    type="text"
                    value={newPlacement || ''}
                    onChange={(e) => setNewPlacement(e.target.value)}
                    placeholder={t('addMachine.enterNewPlacement')}
                  />
                </div>
              </div>

            </div>

            <div className="form-section__title">      
              {t("addMachine.reseller.sectionTitle")}
            </div>
            <div className="form-section">
              <div className="entry-item entry-item__medium">
                <label className="entry-label">{t("addMachine.reseller.companyName")}</label>
                <input
                  className="entry-control"
                  type="text"
                  value={reseller.company_name || ''}
                  onChange={e => setReseller({ ...reseller, company_name: e.target.value })}
                />
              </div>
              <div className="entry-item entry-item__medium">
                <label className="entry-label">{t("addMachine.reseller.address")}</label>
                <input
                  className="entry-control"
                  type="text"
                  value={reseller.address || ''}
                  onChange={e => setReseller({ ...reseller, address: e.target.value })}
                />
              </div>
              <div className="entry-item entry-item__medium">
                <label className="entry-label">{t("addMachine.reseller.contactName")}</label>
                <input
                  className="entry-control"
                  type="text"
                  value={reseller.contact_name || ''}
                  onChange={e => setReseller({ ...reseller, contact_name: e.target.value })}
                />
              </div>
              <div className="entry-item entry-item__medium">
                <label className="entry-label">{t("addMachine.reseller.phone")}</label>
                <input
                  className="entry-control"
                  type="text"
                  value={reseller.contact_phone || ''}
                  onChange={e => setReseller({ ...reseller, contact_phone: e.target.value })}
                />
              </div>
              <div className="entry-item entry-item__medium">
                <label className="entry-label">{t("addMachine.reseller.email")}</label>
                <input
                  className="entry-control"
                  type="email"
                  value={reseller.contact_email || ''}
                  onChange={e => setReseller({ ...reseller, contact_email: e.target.value })}
                />
              </div>
              <div className="entry-item entry-item__medium">
                <label className="entry-label">{t("addMachine.reseller.dateOfPurchase")}</label>
                <input
                  className="entry-control"
                  type="date"
                  value={
                    reseller.date_of_purchase
                      ? new Date(reseller.date_of_purchase).toISOString().slice(0, 10)
                      : ''
                  }
                  onChange={e =>
                    setReseller({
                      ...reseller,
                      date_of_purchase: e.target.value,
                    })
                  }
                />
              </div>
            </div>

<div className="form-section__title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  {t('addMachine.machineResponsible')}
  <button 
    type="button"
    className="button--toggle-section"
    onClick={() => setShowResponsibleTechs(prev => !prev)}
  >
    {showResponsibleTechs ? t('Hide') : t('Show')}
  </button>
</div>

{showResponsibleTechs && (
  <div className="form-section">
    {availableUsers.length > 0 ? (
      availableUsers
        .filter(tech => (tech.userfirstname || tech.username) && tech.useremail)
        .map(tech => {
          const fullName = tech.userfirstname
            ? `${tech.userfirstname} ${tech.userlastname || ''}`.trim()
            : tech.username;

          return (
            <div key={tech.userid} className="entry-item entry-item__full-width">
              <label className="entry-label">
                <input
                  type="checkbox"
                  checked={responsibleTechs.includes(tech.userid)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setResponsibleTechs([...responsibleTechs, tech.userid]);
                    } else {
                      setResponsibleTechs(responsibleTechs.filter(id => id !== tech.userid));
                    }
                  }}
                />
                <strong>{fullName}</strong>
                {tech.company && ` — ${tech.company}`}
              </label>
            </div>
          );
        })
    ) : (
      <p>{t("addMachine.externalTechnicians.noneAvailable")}</p>
    )}
  </div>
)}


            <div className="form-section__title">{t('addMachine.uploadImage')}</div>
            <div 
              className={`form-main-image-section ${dragOver ? 'form-section--drag-over' : ''}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              style={{
                backgroundImage: previewImage ? `url(${previewImage.startsWith('/uploads/machines')
                  ? `${apiBaseUrl}/mnt/api/uploads/machine/${previewImage.replace('/uploads/machines/', '')}`
                  : previewImage})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="file-upload">
                <input type="file" id="files" className="file-upload__input" onChange={handleFileChange} />
                <label htmlFor="files" className="file-upload__label">
                  <button type="button" className="button--icon button--grey" onClick={() => document.getElementById('files').click()}>
                    <AddIcon />
                  </button>
                  <span className="file-upload__filename"></span>
                </label>
              </div>
            </div>

            <div className="form-section__title">{t('addMachine.uploadFiles')}</div>
            <div className="form-section">
              <input
                type="file"
                multiple
                onChange={handleFilesChange}
                className="upload-button"
              />
              {files.length > 0 && (
                <div className="file-titles-list">
                  {files.map((file, index) => (
                    <div key={index} style={{ marginBottom: '5px' }}>
                      <span>{file.name} - </span>
                      <input
                        type="text"
                        value={fileTitles[index] || ''}
                        onChange={(e) => {
                          const newTitles = [...fileTitles];
                          newTitles[index] = e.target.value;
                          setFileTitles(newTitles);
                        }}
                        placeholder="Enter custom title (optional)"
                      />
                      <select
                        value={fileCategories[index] || ''}
                        onChange={(e) => {
                          const newCats = [...fileCategories];
                          newCats[index] = e.target.value;
                          setFileCategories(newCats);
                        }}
                      >
                        <option value="">Select category</option>
                        {availableFileCategories.map((cat, idx) => (
                          <option key={idx} value={cat}>{cat}</option>
                        ))}
                        <option value="Other">Other</option>
                      </select>
                      <input
                        type="text"
                        value={newFileCategories[index] || ''}
                        onChange={(e) => {
                          const newOverrides = [...newFileCategories];
                          newOverrides[index] = e.target.value;
                          setNewFileCategories(newOverrides);
                        }}
                        placeholder="Or add new category"
                      />
                    </div>
                  ))}
                </div>
              )}


              <h5>{t('addMachine.uploadedFiles')}</h5>
              {previewFiles.length > 0 ? (
                <>
                  {/** Render existing files using your UploadedFileItem component */}
                  {previewFiles.map((file, index) => (
                    <UploadedFileItem 
                      key={index} 
                      file={file} 
                      machineid={editMode ? editMachineId : null}
                      onFileRemoved={(removedFilename) => {
                        setPreviewFiles(prev => prev.filter(f => {
                          const fname = f.path.split('/').pop();
                          return fname !== removedFilename;
                        }));
                      }}    
                    />
                  ))}
                  {/** Allow editing category for existing files */}
                  {editMode && (
                    <div className="existing-files-edit">
                      <h5>{t('addMachine.editUploadedFiles')}</h5>
                      {previewFiles.map((file, index) => (
                        <div key={index} style={{ marginBottom: '5px' }}>
                          <span>{file.title || file.path.split('/').pop()} - </span>
                          <select
                            value={file.category || "Other"}
                            onChange={(e) => {
                              const newPreviewFiles = [...previewFiles];
                              newPreviewFiles[index] = { ...newPreviewFiles[index], category: e.target.value };
                              setPreviewFiles(newPreviewFiles);
                            }}
                          >
                            {[...availableFileCategories, "Other"].map((cat, idx) => (
                              <option key={idx} value={cat}>{cat}</option>
                            ))}
                          </select>
                        </div>
                      ))}
                    </div>
                  )}

                                  </>
              ) : (
                <p>{t('addMachine.noFilesUploaded')}</p>
              )}
            </div>
            


            {editMode && (
              <>
                <div className="form-section__title"> 
                  {t("addMachine.externalTechnicians.sectionTitle")}
                </div>
                <div className="form-section">
                  {availableExternalTechs.length > 0 ? (
                    availableExternalTechs.map(tech => (
                      <div key={tech.userid} className="entry-item entry-item__full-width">
                        <label className="entry-label">
                          <input
                            type="checkbox"
                            checked={externalTechs.includes(tech.userid)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setExternalTechs([...externalTechs, tech.userid]);
                              } else {
                                setExternalTechs(externalTechs.filter(id => id !== tech.userid));
                              }
                            }}
                          />
                          <strong>{tech.userfirstname} {tech.userlastname}</strong> — {tech.company}
                        </label>
                      </div>
                    ))
                  ) : (
                    <p>{t("addMachine.externalTechnicians.noneAvailable")}</p>
                  )}
                </div>

                <div className="form-section__title">{t('addMachine.openMaintenanceSchedules')}</div>
              <div className="form-section">
                {['daily', 'weekly', 'monthly', 'annually'].map((type) => (
                  <div key={type} className="maintenance-category">
                    <div>{t(`addMachine.frequency.${type}`)}</div>

                    {machinesMaintenances[type] && machinesMaintenances[type].length > 0 ? (
                      <ul>
                        {machinesMaintenances[type].map((schedule) => (
                          <li key={schedule.scheduleid}>
                            <span>{t('addMachine.scheduleId')}: {schedule.scheduleid}</span>
                            {schedule.descHeader && (
                              <span> | {t('addMachine.description')}: {schedule.descHeader}</span>
                            )}
                            <Link
                              to={{
                                pathname: '/maintenance-schedule',
                                state: { scheduleid: schedule.scheduleid },
                              }}
                              className="btn-primary"
                            >
                              {t('addMachine.edit')}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div>
                        <p>{t('addMachine.noMaintenanceScheduled')}</p>
                        <Link
                          to={{
                            pathname: '/maintenance-schedule',
                            state: { machineid: editMachineId, maintenance_type: type },
                          }}
                          className="btn-primary"
                        >
                          {t('addMachine.addNew')}
                        </Link>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              </>
            )}

            <div className="form-submit">
              <button type="submit" className="button--blue">
                {editMode ? t('addMachine.btnSaveEditMachine') : t('addMachine.btnSaveNewMachine')}
              </button>
              <div className="top-menu__button-space"></div>
              <button
                type="button"
                className="button--grey"
                onClick={() => {
                  setShowForm(false);
                  setShowContent(true);
                  setFormVisible(false);
                  setEditMode(false);
                  setEditMachineId(null);
                }}
              >
                {t('personnelManagement.cancel')}
              </button>
            </div>
          </div>
        </form>
      )}

      {showContent && (
        <div className="content">
          <div className="top-menu">
            <div className="top-menu__divider"></div>
            <div
              className="top-menu__icon-button top-menu__filter-button"
              onClick={() => setShowFilters(!showFilters)}
            >
              <FilterIcon />
            </div>

            {permissionsLoaded && permissions.can_edit && (
              <button
                type="button"
                className="button--icon-add button--green"
                onClick={() => {
                  setShowForm(true);
                  setShowContent(false);
                }}
              >
                <AddIcon /> {t('addMachine.btnNewMachine')}
              </button>
            )}
          </div>


          <div className="content__main-title">{t('addMachine.machineList')}</div>
          


          {/* Summary Section */}
          <div class="header-info-container">
              <div class="header-info-container__title">Details</div>
              <div class="header-info-container__inner">
                  <table>
                      <tbody>
                          <tr><td>{t("costBreakdown.overAllMachineCost")}</td><td>
                          {currencyPosition === 'left' 
                            ? ` ${currencySymbol}${overAllMachineCost.toFixed(2)} ` 
                            : ` ${overAllMachineCost.toFixed(2)} ${currencySymbol} `
                          }
                          </td></tr>
                      </tbody>
                  </table>    
              </div>
          </div>



          <GroupedDataTable
            groupedData={filteredMachines}
            isFiltered={false}
            headers={[
              {
                label: t("addMachine.machineName"),
                accessor: "machine",
                elasticCell: true,
                colorStyle: "block",
                colorValueFrom: (item) => getPriorityClass(item.priority),
              },
              {
                label: t("addMachine.priority"),
                render: (item) => item.priority || 'N/A',
                colorStyle: "circle",
                colorValueFrom: (item) => getPriorityClass(item.priority),
                hideMobile: true,
              },
              {
                label: t("addMachine.groupName"),
                accessor: "dncmaxgroupname",
                hideMobile: true,
              },
              {
                label: t("addMachine.category"),
                accessor: "category",
                hideMobile: true,
              },
              {
                label: t("addMachine.system"),
                accessor: "system",
                hideMobile: true,
              },
              {
                label: t("TotalMachineCost.Label"),
                render: (item) =>
                  item.machineTotalCost === undefined
                    ? t("TotalMachineCost.Calculating")
                    : currencyPosition === 'left'
                      ? `${currencySymbol} ${(item.machineTotalCost || 0).toFixed(2)}`
                      : `${(item.machineTotalCost || 0).toFixed(2)} ${currencySymbol}`,
                onClick: handleShowCostDetails,
                clickableRowData: true,
                hideMobile: false,
              }
          ]}
            rowKeyFn={(item) => item.machineid}
            getPrimaryActionLabel={() => t('addMachine.edit')}
            onPrimaryAction={(item) => handleEdit(item.machineid)}
            groupMeta={Object.fromEntries(
              Object.keys(filteredMachines).map((group) => [
                group,
                {
                  title: group,
                  description: '', // Optional: add more detail if needed
                  emptyMessage: t('addMachine.noMachinesInGroup'),
                },
              ])
            )}
            contextualOptionsFn={(item) => {
              const options = [];

              options.push({
                label: t("addMachine.showQRCode"),
                onClick: (e) => {
                  e.preventDefault();
                  setQrCodeMachine(item.machineid);
                },
              });

              if (permissions.can_delete) {
                options.push({
                  label: t("addMachine.delete"),
                  onClick: (e) => {
                    e.preventDefault();
                    confirmDelete(item.machineid);
                  },
                });
              }

              return options;
            }}
          />

          {qrCodeMachine && (
            <div className="inline-modal-overlay" onClick={() => setQrCodeMachine(null)}>
              <div className="inline-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="inline-modal-close" onClick={() => setQrCodeMachine(null)}>
                  ×
                </button>
                <MachineQRCode machineId={qrCodeMachine} />
              </div>
            </div>
          )}

        </div>

      )}

      {isCostModalOpen && selectedMachineCost && (
        <div className="modal-overlay" onClick={() => setIsCostModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{t("costBreakdown.title")}</h2>
            <p><strong>{t("costBreakdown.serviceReportTimeCost")}:</strong> 
              {currencyPosition === 'left' 
                ? ` ${currencySymbol} ${selectedMachineCost.serviceReportTimeCost.toFixed(2)}`
                : ` ${selectedMachineCost.serviceReportTimeCost.toFixed(2)} ${currencySymbol}`}
            </p>
            <p><strong>{t("costBreakdown.serviceReportMaterialCost")}:</strong> 
              {currencyPosition === 'left' 
                ? ` ${currencySymbol} ${selectedMachineCost.serviceReportMaterialCost.toFixed(2)}`
                : ` ${selectedMachineCost.serviceReportMaterialCost.toFixed(2)} ${currencySymbol}`}
            </p>
            <p><strong>{t("costBreakdown.serviceReportTotalCost")}:</strong> 
              {currencyPosition === 'left' 
                ? ` ${currencySymbol} ${selectedMachineCost.serviceReportTotalCost.toFixed(2)}`
                : ` ${selectedMachineCost.serviceReportTotalCost.toFixed(2)} ${currencySymbol}`}
            </p>
            <hr />
            <p><strong>{t("costBreakdown.maintenanceTimeCost")}:</strong> 
              {currencyPosition === 'left' 
                ? ` ${currencySymbol} ${selectedMachineCost.maintenanceTimeCost.toFixed(2)}`
                : ` ${selectedMachineCost.maintenanceTimeCost.toFixed(2)} ${currencySymbol}`}
            </p>
            <p><strong>{t("costBreakdown.maintenanceMaterialCost")}:</strong> 
              {currencyPosition === 'left' 
                ? ` ${currencySymbol} ${selectedMachineCost.maintenanceMaterialCost.toFixed(2)}`
                : ` ${selectedMachineCost.maintenanceMaterialCost.toFixed(2)} ${currencySymbol}`}
            </p>
            <p><strong>{t("costBreakdown.maintenanceTotalCost")}:</strong> 
              {currencyPosition === 'left' 
                ? ` ${currencySymbol} ${selectedMachineCost.maintenanceTotalCost.toFixed(2)}`
                : ` ${selectedMachineCost.maintenanceTotalCost.toFixed(2)} ${currencySymbol}`}
            </p>
            <hr />
            <p><strong>{t("costBreakdown.totalMachineCost")}:</strong> 
              {currencyPosition === 'left' 
                ? ` ${currencySymbol} ${selectedMachineCost.machineTotalCost.toFixed(2)}`
                : ` ${selectedMachineCost.machineTotalCost.toFixed(2)} ${currencySymbol}`}
            </p>
            <hr />
            <button className="button--grey" onClick={() => setIsCostModalOpen(false)}>
              {t("costBreakdown.closeButton")}
            </button>
          </div>
        </div>
      )}

    </>
  );
};

export default AddMachine;
